export enum WebsocketCode {
    TERMS_ACCEPTED = '001',
    BANK_SELECTED = '002',
    LOGIN_FAILED = '003',
    LOGIN_SUCCESS = '004',
    AGGREGATION_OK = '005',
    AGGREGATION_KO = '006',
    CLIENT_DATA = '007'
}
